import React from 'react';
import { DAYS, MONTHS, YEARS } from './constants.utils';

/**
 * Gestion du tooltip password.
 * @param messagesPassword liste des messages
 */
export function messageinfosPassword(messagesPassword: string[]) {
    //Infos texte pour le champ mot de passe
    return messagesPassword.length > 0 ? (
        <>
            <p>Le mot de passe doit contenir au moins : </p>
            <ul>
                {messagesPassword.map(value => (
                    <li key={value}>{value}</li>
                ))}
            </ul>
        </>
    ) : null;
}

/**
 * Function for return empty string if value is null or undefined
 * @param value
 */
export function getValueOrEmpty<T = any>(value: T) {
    return value ? value : '';
}

/**
 * Mapping données type de consommations.
 * @param text
 */
export function mappingTypConso(text: string) {
    let newText = '';
    switch (text) {
        case YEARS:
            newText = 'Années';
            break;
        case MONTHS:
            newText = 'Mois';
            break;
        case DAYS:
            newText = 'Jours';
            break;
        default:
            break;
    }
    return newText;
}
